import classNames from 'classnames';
import React, { useContext } from 'react';
import { GradientContext, BackgroundContext } from '../../contexts/PageContexts';

// import { useTranslation } from 'next-i18next';
// import PropTypes from 'prop-types';
import styles from './GradientBlurb.module.scss';

const GradientBlurb = ({ isReversed, modifiers = [] }) => {
    const gradient = useContext(GradientContext) || 'PurpleBlue';
    const background = useContext(BackgroundContext) || false;

    const { whiteBackground } = background;
    const classes = classNames(
        styles['Root'],
        {
            [styles['Reverse']]: isReversed,
        },
        styles[gradient],
        modifiers.map((m) => styles[m])
    );
    return (
        !whiteBackground && (
            <span className={classes}>
                <span className={styles['Bg']} />
            </span>
        )
    );
};

GradientBlurb.propTypes = {};

export default GradientBlurb;
